<template>
  <section>
    <h2 class="header">{{ $t('payments.buyer_name') }}:</h2>
    <v-text-field outlined
      dense
      persistent-hint
      type="text"
      :value="value"
      :error="!value"
      :hint="$t('errors.required')"
      @input="$emit('input', $event)"
      :rules="[$vRequired]"></v-text-field>
  </section>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'PaymentBuyerName',
  props: {
    value: String,
    price: Number,
    creditCardMin: { type: Number, default: 1000 }
  }
}
</script>
